export type ProjectInfo =
  | { kind: 'client', client: string, location: string, con?: string }
  | { kind: 'book', authors: string, codeLabel: string, codeValue: string, editor: string }

export type Project = {
  key: string,
  type: string,
  title: string,
  info: ProjectInfo,
  projectText: string,
  skills: string[],
  images: string[],
}

export const projects = (isMdUp: boolean): Record<
  'graphic' | 'illustration',
  Record<number, Project>
> => ({
  graphic: {
    1: {
      key: 'museo-preistorico',
      type: 'Exhibition Design',
      title: 'Museo Preistorico\ndei balzi rossi',
      info: {
        kind: 'client',
        client: 'Direzione Regionale Musei Liguria',
        location: 'Museo Preistorico dei Balzi Rossi, Ventimiglia (IM), Italy',
        con: 'Arch. Giuseppina Schmidt e Dott. Elio Micco',
      },
      projectText: 'Re-Design delle grafiche dei pannelli e allestimento  museale del Museo Vecchio e Nuovo.\n\nLa nuova grafica si è  basata sull\'identificazione del nuovo target d\'utenza del  museo: famiglie di turisti in viaggio da e verso al Francia, gite scolastiche sia francesi che italiane.\n\nSi è utilizzato colori  vivaci, font di facile lettura e illustrazioni riviste in chiave  moderna.',
      skills: ['Graphic Design', 'Exhibitions Design', 'Progettazione 3D', 'Allestimento', 'Team Work', 'Problem Solving', 'Rispetto delle deadline'],
      images: isMdUp ? [
        Img_Museo_Preistorico_1,
        Img_Museo_Preistorico_2,
        Img_Museo_Preistorico_3,
        Img_Museo_Preistorico_4,
        Img_Museo_Preistorico_5,
        Img_Museo_Preistorico_6,
        Img_Museo_Preistorico_7,
        Img_Museo_Preistorico_8,
      ] : [
        Img_Museo_Preistorico_1,
        Img_Museo_Preistorico_2,
        Img_Museo_Preistorico_3,
        Img_Museo_Preistorico_4,
        Img_Museo_Preistorico_5,
        Img_Museo_Preistorico_6,
        Img_Museo_Preistorico_8,
        Img_Museo_Preistorico_7,
      ],
    },
    2: {
      key: 'museo-luni',
      type: 'Exhibition Design',
      title: 'Museo e Zona Archeologica\ndi Luni',
      info: {
        kind: 'client',
        client: 'Direzione Regionale Musei Liguria',
        location: 'Museo Archeologico Nazionale e zona archeologica di Luni, La Spezia, Italy',
        con: 'Arch. Giuseppina Schmidt e Dott. Elio Micco',
      },
      projectText: 'Realizzazione e progettazione del supporto della  pannellistica esterna del percorso della zona archeologica.\n\nProgettazione della pannellistica ed allestimento della  mostra temporanea “Il teatro di LUNA, settant’anni di  ricerche archeologiche” (2019).\n\nProgettazione della pannellistica ed allestimento nel casale Maurino “Il Tempio della Dea Luna” (2023).',
      skills: ['Graphic Design', 'Progettazione 3D', 'Allestimento', 'Team Work', 'Problem Solving', 'Rispetto delle deadline'],
      images: isMdUp ? [
        Img_Museo_Luni_1,
        Img_Museo_Luni_2,
        Img_Museo_Luni_3,
        Img_Museo_Luni_4,
        Img_Museo_Luni_5,
        Img_Museo_Luni_6,
        Img_Museo_Luni_7,
        Img_Museo_Luni_8,
      ] : [
        Img_Museo_Luni_1,
        Img_Museo_Luni_3,
        Img_Museo_Luni_5,
        Img_Museo_Luni_2,
        Img_Museo_Luni_4,
        Img_Museo_Luni_6,
        Img_Museo_Luni_8,
        Img_Museo_Luni_7,
      ],
    },
    3: {
      key: 'galleria-puglia',
      type: 'Exhibition Design',
      title: 'Galleria Nazionale\ndella Puglia Bitonto',
      info: {
        kind: 'client',
        client: 'Digi-Art di Rosanna Pesce',
        location: 'Galleria Nazionale della Puglia “Girolamo e Rosaria Devanna” Bitonto, Bari, Italy',
      },
      projectText: 'Realizzazione e progettazione del re-design della pinacoteca  Galleria Nazionale della Puglia, Bitonto.\n\nIl nuovo design pervede la realizzazione di pannelli easy to  read nel rispetto delle normative vigenti, nella creazione  di didascalie, brochures e supporti digital come splash  screen, icone e sotto pancia di video per rendere l’esperienza all’interno del museo immersiva grazie all’immagine  coordinata.',
      skills: ['Graphic Design', 'Exhibitions Design', 'Allestimento', 'Problem Solving', 'Rispetto delle deadline'],
      images: isMdUp ? [
        Img_Galleria_Puglia_1,
        Img_Galleria_Puglia_2,
        Img_Galleria_Puglia_3,
        Img_Galleria_Puglia_4,
        Img_Galleria_Puglia_5,
        Img_Galleria_Puglia_6,
        Img_Galleria_Puglia_7,
        Img_Galleria_Puglia_8,
      ] : [
        Img_Galleria_Puglia_1,
        Img_Galleria_Puglia_3,
        Img_Galleria_Puglia_2,
        Img_Galleria_Puglia_4,
        Img_Galleria_Puglia_6,
        Img_Galleria_Puglia_5,
        Img_Galleria_Puglia_8,
        Img_Galleria_Puglia_7,
      ],
    },
    4: {
      key: 'sos-wedding',
      type: 'Brand Identity',
      title: 'SOS Wedding & Event planner',
      info: {
        kind: 'client',
        client: 'Francesca Sgargi o Sgarzi, Wedding & Event Planner',
        location: 'Bologna, Italy',
        con: 'Stilla Design',
      },
      projectText: 'Realizzazione del logo, della brand identity e del sito web di SOS Wedding & Events Planner. Francesca Sgargi o Sgarzi è una wedding planner emergente bolognese il suo  logo è stato pensato riprendendo dal Codice Morse con il segnale universale  di richiesta urgente di soccorso: SOS, riprendendo la sigla del suo cognome (Sgragi O Sgarzi) all’interno del logo e creando allo stesso tempo un  logo ed un claim.\n\nhttps://www.francescasgargiosgarzi.com/',
      skills: ['Graphic Design', 'Logo & Brand Identity', 'Web Design', 'Team Working', 'Relazione con il cliente', 'Rispetto delle deadline'],
      images: isMdUp ? [
        Img_SOS_Wedding_1,
        Img_SOS_Wedding_2,
        Img_SOS_Wedding_3,
        Img_SOS_Wedding_4,
        Img_SOS_Wedding_5,
        Img_SOS_Wedding_6,
        Img_SOS_Wedding_7,
        Img_SOS_Wedding_8,
      ] : [
        Img_SOS_Wedding_1,
        Img_SOS_Wedding_2,
        Img_SOS_Wedding_4,
        Img_SOS_Wedding_3,
        Img_SOS_Wedding_5,
        Img_SOS_Wedding_6,
        Img_SOS_Wedding_7,
        Img_SOS_Wedding_8,
      ],
    },
    5: {
      key: 'p38-regis',
      type: 'Brand Identity',
      title: 'P38 REGIS autoriparazione e distribuzione',
      info: {
        kind: 'client',
        client: 'P38 Regis, Auto riparazione e distribuzione di carburante',
        location: 'San Remo (IM), Italy',
      },
      projectText: 'Il rebranding di P38 REGIS consiste nella scelta di un nuovo font e di una nuova palette di colori, declinabili a secondo  dell’utilizzo del logo, e nella creazione del pittogramma P38 da utilizzare nel merchandising aziendale.\n\nLa nuova proposta svecchia il logo precedente senza  dimenticare i valori dell’attività nel trasmettere la sua storia. ',
      skills: ['Graphic Design', 'Logo & Brand Identity', 'Team Working', 'Relazione con il cliente', 'Rispetto delle deadline'],
      images: isMdUp ? [
        Img_P38_Regis_1,
        Img_P38_Regis_2,
        Img_P38_Regis_3,
        Img_P38_Regis_4,
        Img_P38_Regis_5,
        Img_P38_Regis_6,
        Img_P38_Regis_7,
        Img_P38_Regis_8,
      ] : [
        Img_P38_Regis_1,
        Img_P38_Regis_2,
        Img_P38_Regis_3,
        Img_P38_Regis_4,
        Img_P38_Regis_7,
        Img_P38_Regis_8,
        Img_P38_Regis_6,
        Img_P38_Regis_5,
      ],
    },
    6: {
      key: 'bologna-sui-muri',
      type: 'Brand Identity',
      title: 'BOLOGNA sui muri',
      info: {
        kind: 'client',
        client: 'Mattia Pirani',
        location: 'Bologna, Italy',
      },
      projectText: 'Realizzazione del logo per il merchandising di Bologna sui muri.\n\nIl progetto prevede la stampa digitale di magliette con foto delle iconiche “scritte sui muri” di Bologna.\n\nDa qui naming e logo: il primo scritto a mano proprio come una scritta su un muro; il secondo vettoriale, rappresentante uno dei simboli più significativi di Bologna: il Santuraio Madonna di San Luca.',
      skills: ['Graphic Design', 'Logo & Brand Identity', 'Relazione con il cliente', 'Rispetto delle deadline'],
      images: isMdUp ? [
        Img_Bologna_Sui_Muri_1,
        Img_Bologna_Sui_Muri_2,
        Img_Bologna_Sui_Muri_3,
        Img_Bologna_Sui_Muri_4,
        Img_Bologna_Sui_Muri_5,
        Img_Bologna_Sui_Muri_6,
      ] : [
        Img_Bologna_Sui_Muri_1,
        Img_Bologna_Sui_Muri_2,
        Img_Bologna_Sui_Muri_3,
        Img_Bologna_Sui_Muri_4,
        Img_Bologna_Sui_Muri_6,
        Img_Bologna_Sui_Muri_5,
      ],
    },
    7: {
      key: 'ecoeridania',
      type: 'Marketing illustration',
      title: 'Ecoeridania S.p.a smaltimento\nrifiuti speciali',
      info: {
        kind: 'client',
        client: 'Gruppo Ecoeridania S.p.a - Smaltimento rifiuti speciali',
        location: 'Genova, Italy',
      },
      projectText: 'Creazione della mascotte illustrata Bernardo per il GRUPPO  ECOERIDANIA S.P.A. a scopo divulgativo e pubblicitario.  La mission del progetto è stata quella rendere argomenti ostici come  lo smaltimento dei rifiuti alla “portata di tutti”. Bernardo rispecchia  caratteristiche aziendali: Sicurezza, Tempestività e Professionalità e i suoi obiettivi sono la raccolta, il trasporto, lo stoccaggio, il  trattamento e lo smaltimento di rifiuti speciali, nel pieno rispetto  delle normative vigenti. ',
      skills: ['Digital Illustration', 'Brand Identity', 'Stress managing', 'Rispetto delle deadline'],
      images: isMdUp ? [
        Img_Ecoeridania_1,
        Img_Ecoeridania_2,
        Img_Ecoeridania_3,
        Img_Ecoeridania_4,
        Img_Ecoeridania_5,
        Img_Ecoeridania_6,
        Img_Ecoeridania_7,
        Img_Ecoeridania_8,
      ] : [
        Img_Ecoeridania_1,
        Img_Ecoeridania_6,
        Img_Ecoeridania_3,
        Img_Ecoeridania_5,
        Img_Ecoeridania_2,
        Img_Ecoeridania_4,
        Img_Ecoeridania_7,
        Img_Ecoeridania_8,
      ],
    },
    8: {
      key: 'terrazza-bonsai',
      type: 'Marketing illustration',
      title: 'Terrazza Bonsai - Multistudio',
      info: {
        kind: 'client',
        client: 'Terrazza Bonsai - Multistudio',
        location: 'Genova, Italy',
      },
      projectText: 'Il progetto di comunicazione per Terrazza Bonsai mira a rafforzare l\'identità del brand, enfatizzando la sua multidisciplinarietà e l\'unicità delle sue location. Elemento centrale del progetto sono tre illustrazioni: la prima rappresenta un Bonsai, simbolo di cura nei dettagli e capacità di far crescere idee in diverse direzioni; le altre due raffigurano le location del Multistudio, catturando l\'atmosfera creativa degli spazi. Queste, rafforzano la visibilità e il posizionamento del brand, attirando nuovi clienti e consolidando quelli esistenti.',
      skills: ['Digital Illustration', 'Brand Identity', 'Stress managing', 'Rispetto delle deadline'],
      images: isMdUp ? [
        Img_Terrazza_Bonsai_1,
        Img_Terrazza_Bonsai_2,
        Img_Terrazza_Bonsai_3,
        Img_Terrazza_Bonsai_4,
        Img_Terrazza_Bonsai_5,
        Img_Terrazza_Bonsai_6,
      ] : [
        Img_Terrazza_Bonsai_1,
        Img_Terrazza_Bonsai_2,
        Img_Terrazza_Bonsai_3,
        Img_Terrazza_Bonsai_4,
        Img_Terrazza_Bonsai_6,
        Img_Terrazza_Bonsai_5,
      ],
    },
    9: {
      key: 'falconeri-sanremo',
      type: 'Marketing illustration',
      title: 'Falconeri per SANREMO 2021',
      info: {
        kind: 'client',
        client: 'Falconeri San Remo per il  Festival di Sar Remo 2021',
        location: 'San Remo (IM), Italy',
        con: 'Olio Sommariva S.r.l.',
      },
      projectText: 'La linea di illustrazioni FALCONERI Sanremo è stata creata e progettata sia per decorare il negozio che come etichette per le bottigliette di olio Sommariva, cadeau conseganto ad ogni cliente per celebrare la settimana del Festival di Sanremo 2021.\n\nIl claim "Music Connects People" connette idealmente ogni nuovo cliente con una musica infinita e silenziosa che, durante la Settimana del Festival ha lo scopo di creare un\'atmosfera di leggerezza e spensieratezza.',
      skills: ['Digital Illustration', 'Graphic Design', 'Brand Design', 'Problem Solving', 'Rispetto delle deadline'],
      images: isMdUp ? [
        Img_Falconeri_Sanremo_1,
        Img_Falconeri_Sanremo_2,
        Img_Falconeri_Sanremo_3,
        Img_Falconeri_Sanremo_4,
        Img_Falconeri_Sanremo_5,
        Img_Falconeri_Sanremo_6,
        Img_Falconeri_Sanremo_7,
        Img_Falconeri_Sanremo_8,
      ] : [
        Img_Falconeri_Sanremo_1,
        Img_Falconeri_Sanremo_2,
        Img_Falconeri_Sanremo_3,
        Img_Falconeri_Sanremo_4,
        Img_Falconeri_Sanremo_5,
        Img_Falconeri_Sanremo_6,
        Img_Falconeri_Sanremo_7,
        Img_Falconeri_Sanremo_8,
      ],
    },
  },
  illustration: {
    1: {
      key: 'matematicare',
      type: 'Children\'s Book',
      title: 'Matemaricare - Racconti\nper fare matematica',
      info: {
        kind: 'book',
        authors: 'Chiara Franconi e Nora Gallia',
        codeLabel: 'ISBN',
        codeValue: '9791254585887',
        editor: 'PubMe collana GemmaViva',
      },
      projectText: 'Questo libro raccoglie tre racconti in rima a tema matematico per accompagnare bambini, educatori e insegnanti nelle loro esperienze matematiche: LA DISPENSA DELLO SCOIATTOLO: classificazione; DENTRO E FUORI: spazi aperti e chiusi; I DUE CASTELLI: strategie che facilitano il conteggio.\n\nParole e immagini coinvolgono, divertono e invitano i bambini a cercare, assieme ai protagonisti, possibili soluzioni ai problemi. Compito dell’adulto è offrire materiali, esperienze e  allestimenti che permettano  di mettersi in gioco per esplorare e approfondire le proprie competenze matematiche.',
      skills: ['Digital Illustration', 'Layout', 'Stress managing', 'Rispetto delle deadline'],
      images: isMdUp ? [
        Img_Matematicare_1,
        Img_Matematicare_2,
        Img_Matematicare_3,
        Img_Matematicare_4,
        Img_Matematicare_5,
        Img_Matematicare_6,
      ] : [
        Img_Matematicare_1,
        Img_Matematicare_3,
        Img_Matematicare_5,
        Img_Matematicare_4,
        Img_Matematicare_6,
        Img_Matematicare_2,
      ],
    },
    2: {
      key: 'ora-guido-io',
      type: 'Children\'s Book',
      title: 'Ora guido io!',
      info: {
        kind: 'book',
        authors: 'Valentina D\'Amora, Simone Morini e Nora Gallia',
        codeLabel: 'EAN',
        codeValue: '9788833669496',
        editor: 'PubMe collana GemmaViva',
      },
      projectText: 'Dall\'abitacolo della propria utilitaria, una bambina, in viaggio con la fantasia e con la sua giraffa di pezza, ci guiderà alla scoperta del mondo.\n\nAttraverso il parabrezza che incornicia ogni scenario, ci accorgeremo di come si stanno trasformando i paradisi naturali del nostro pianeta.',
      skills: ['Digital Illustration', 'Layout', 'Stress managing', 'Rispetto delle deadline'],
      images: isMdUp ? [
        Img_Ora_Guido_Io_1,
        Img_Ora_Guido_Io_2,
        Img_Ora_Guido_Io_3,
        Img_Ora_Guido_Io_4,
        Img_Ora_Guido_Io_5,
        Img_Ora_Guido_Io_6,
      ] : [
        Img_Ora_Guido_Io_2,
        Img_Ora_Guido_Io_1,
        Img_Ora_Guido_Io_5,
        Img_Ora_Guido_Io_3,
        Img_Ora_Guido_Io_4,
        Img_Ora_Guido_Io_6,
      ],
    },
    3: {
      key: 'ecoconsigli',
      type: 'Children\'s Book',
      title: 'Gli eco-consigli del panda',
      info: {
        kind: 'book',
        authors: 'Marta Misurale e Nora Gallia',
        codeLabel: 'ISBN',
        codeValue: '9788884801661',
        editor: 'Tormena Editore',
      },
      projectText: 'Questo libro, stampato interamente in carta riciclata con uso minimo di inchiostro, è sia per bambini che per adulti e affronta le tematiche di impegno quotidiano per aiutare il nostro pianeta.\n\nCon la semplicità di una filastrocca in rima e di disegni in bianco e nero, il bambino, ma anche l\'adulto, è guidato in un percorso di consapevolezza: anche le sue azioni possono contribuire a rendere il mondo un posto migliore.',
      skills: ['Digital Illustration', 'Layout', 'Stress managing', 'Rispetto delle deadline'],
      images: isMdUp ? [
        Img_Ecoconsigli_1,
        Img_Ecoconsigli_2,
        Img_Ecoconsigli_3,
        Img_Ecoconsigli_4,
        Img_Ecoconsigli_5,
        Img_Ecoconsigli_6,
      ] : [
        Img_Ecoconsigli_1,
        Img_Ecoconsigli_3,
        Img_Ecoconsigli_2,
        Img_Ecoconsigli_4,
        Img_Ecoconsigli_6,
        Img_Ecoconsigli_5,
      ],
    },
    4: {
      key: 'luogocomune',
      type: 'Work on commission',
      title: 'Luogocomune a coworking space',
      info: {
        kind: 'client',
        client: 'Luogocomune - a coworking space presso Bologna Centrale',
        location: 'Bologna, Itlay',
      },
      projectText: 'All\'interno del co-working space LUOGOCOMUNE ci sono una serie di illustrazioni relizzate appositamente per un luogo di condivisione, coworking e networking nella città di Bologna.\n\nL\'idea fondante nasce dai tre nomi che la descrivono: la rossa (per tipico uso dei mattoni rossi nell\'architettura della città), la dotta (per l\'università più antica d\'Europa) e la grassa (per il cibo).',
      skills: ['Digital Illustration', 'Brand Identity', 'Stress managing', 'Rispetto delle deadline'],
      images: isMdUp ? [
        Img_Luogocomune_1,
        Img_Luogocomune_2,
        Img_Luogocomune_3,
        Img_Luogocomune_4,
        Img_Luogocomune_5,
        Img_Luogocomune_6,
      ] : [
        Img_Luogocomune_1,
        Img_Luogocomune_3,
        Img_Luogocomune_2,
        Img_Luogocomune_5,
        Img_Luogocomune_4,
        Img_Luogocomune_6,
      ],
    },
    5: {
      key: 'carbonara',
      type: 'Work on commission',
      title: '“carbonara Stories” - salumificio fratelli beretta s.p.a.',
      info: {
        kind: 'client',
        client: 'Salumificio Fratelli Beretta S.p.a.',
        location: 'Trezzo (MI), Itlay',
      },
      projectText: 'Le cinque locandine illustrate sono ispirate a film famosi per celebrare i vincitori del contest “Carbonara Stories” per il Carbonara Day.\n\nOgni locandina gioca con il titolo di un film, sostituendo parole chiave con riferimenti alla Carbonara o elementi legati a questo piatto iconico. Le illustrazioni catturano l\'essenza dei film originali, aggiungendo un tocco di ironia e creatività culinaria, trasformando ogni titolo in un\'esperienza visiva unica e divertente che rende omaggio a questa amata ricetta italiana.',
      skills: ['Digital Illustration', 'Stress managing', 'Rispetto delle deadline'],
      images: isMdUp ? [
        Img_Carbonara_1,
        Img_Carbonara_2,
        Img_Carbonara_3,
        Img_Carbonara_4,
      ] : [
        Img_Carbonara_1,
        Img_Carbonara_3,
        Img_Carbonara_4,
        Img_Carbonara_2,
      ],
    },
    6: {
      key: 'collettivo',
      type: 'Work on commission',
      title: 'Senz\'api finisce la favola - Associazione l\'uliveto',
      info: {
        kind: 'client',
        client: 'Associazione l\'Uliveto - Ex Bocciofila Tanini “Il Geranio”',
        location: 'Genova, Itlay',
      },
      projectText: 'Le illustrazioni realizzate per la ex Bocciofila Tanini “Il Geranio” catturano la vitalità e la bellezza delle api, simboli del nostro impegno per la biodiversità e l\'agricoltura sostenibile. Queste immagini, pensate per etichette, social e magliette, celebrano la connessione tra le api, i nostri orti e le arnie, esprimendo il legame profondo tra la natura e il nostro lavoro quotidiano per preservarla. Ogni illustrazione è un omaggio al loro ruolo cruciale nell\'ecosistema, rappresentando al contempo i valori e la missione della nostra associazione.',
      skills: ['Digital Illustration', 'Brand Identity ', 'Stress managing'],
      images: isMdUp ? [
        Img_Collettivo_1,
        Img_Collettivo_2,
        Img_Collettivo_3,
        Img_Collettivo_4,
        Img_Collettivo_5,
        Img_Collettivo_6,
      ] : [
        Img_Collettivo_2,
        Img_Collettivo_1,
        Img_Collettivo_3,
        Img_Collettivo_4,
        Img_Collettivo_6,
        Img_Collettivo_5,
      ],
    },
  }
})

// Graphic

import Img_Museo_Preistorico_1 from '../assets/graphic/museo-preistorico/1.jpg'
import Img_Museo_Preistorico_2 from '../assets/graphic/museo-preistorico/2.jpg'
import Img_Museo_Preistorico_3 from '../assets/graphic/museo-preistorico/3.jpg'
import Img_Museo_Preistorico_4 from '../assets/graphic/museo-preistorico/4.jpg'
import Img_Museo_Preistorico_5 from '../assets/graphic/museo-preistorico/5.jpg'
import Img_Museo_Preistorico_6 from '../assets/graphic/museo-preistorico/6.jpg'
import Img_Museo_Preistorico_7 from '../assets/graphic/museo-preistorico/7.jpg'
import Img_Museo_Preistorico_8 from '../assets/graphic/museo-preistorico/8.jpg'

import Img_Museo_Luni_1 from '../assets/graphic/museo-luni/1.jpg'
import Img_Museo_Luni_2 from '../assets/graphic/museo-luni/2.jpg'
import Img_Museo_Luni_3 from '../assets/graphic/museo-luni/3.jpg'
import Img_Museo_Luni_4 from '../assets/graphic/museo-luni/4.jpg'
import Img_Museo_Luni_5 from '../assets/graphic/museo-luni/5.jpg'
import Img_Museo_Luni_6 from '../assets/graphic/museo-luni/6.jpg'
import Img_Museo_Luni_7 from '../assets/graphic/museo-luni/7.jpg'
import Img_Museo_Luni_8 from '../assets/graphic/museo-luni/8.jpg'

import Img_Galleria_Puglia_1 from '../assets/graphic/galleria-puglia/1.jpg'
import Img_Galleria_Puglia_2 from '../assets/graphic/galleria-puglia/2.jpg'
import Img_Galleria_Puglia_3 from '../assets/graphic/galleria-puglia/3.jpg'
import Img_Galleria_Puglia_4 from '../assets/graphic/galleria-puglia/4.jpg'
import Img_Galleria_Puglia_5 from '../assets/graphic/galleria-puglia/5.jpg'
import Img_Galleria_Puglia_6 from '../assets/graphic/galleria-puglia/6.jpg'
import Img_Galleria_Puglia_7 from '../assets/graphic/galleria-puglia/7.jpg'
import Img_Galleria_Puglia_8 from '../assets/graphic/galleria-puglia/8.jpg'

import Img_SOS_Wedding_1 from '../assets/graphic/sos-wedding/1.jpg'
import Img_SOS_Wedding_2 from '../assets/graphic/sos-wedding/2.jpg'
import Img_SOS_Wedding_3 from '../assets/graphic/sos-wedding/3.jpg'
import Img_SOS_Wedding_4 from '../assets/graphic/sos-wedding/4.jpg'
import Img_SOS_Wedding_5 from '../assets/graphic/sos-wedding/5.jpg'
import Img_SOS_Wedding_6 from '../assets/graphic/sos-wedding/6.jpg'
import Img_SOS_Wedding_7 from '../assets/graphic/sos-wedding/7.jpg'
import Img_SOS_Wedding_8 from '../assets/graphic/sos-wedding/8.jpg'

import Img_P38_Regis_1 from '../assets/graphic/p38-regis/1.jpg'
import Img_P38_Regis_2 from '../assets/graphic/p38-regis/2.jpg'
import Img_P38_Regis_3 from '../assets/graphic/p38-regis/3.jpg'
import Img_P38_Regis_4 from '../assets/graphic/p38-regis/4.jpg'
import Img_P38_Regis_5 from '../assets/graphic/p38-regis/5.jpg'
import Img_P38_Regis_6 from '../assets/graphic/p38-regis/6.jpg'
import Img_P38_Regis_7 from '../assets/graphic/p38-regis/7.jpg'
import Img_P38_Regis_8 from '../assets/graphic/p38-regis/8.jpg'

import Img_Bologna_Sui_Muri_1 from '../assets/graphic/bologna-sui-muri/1.jpg'
import Img_Bologna_Sui_Muri_2 from '../assets/graphic/bologna-sui-muri/2.jpg'
import Img_Bologna_Sui_Muri_3 from '../assets/graphic/bologna-sui-muri/3.jpg'
import Img_Bologna_Sui_Muri_4 from '../assets/graphic/bologna-sui-muri/4.jpg'
import Img_Bologna_Sui_Muri_5 from '../assets/graphic/bologna-sui-muri/5.jpg'
import Img_Bologna_Sui_Muri_6 from '../assets/graphic/bologna-sui-muri/6.jpg'

import Img_Ecoeridania_1 from '../assets/graphic/ecoeridania/1.jpg'
import Img_Ecoeridania_2 from '../assets/graphic/ecoeridania/2.jpg'
import Img_Ecoeridania_3 from '../assets/graphic/ecoeridania/3.jpg'
import Img_Ecoeridania_4 from '../assets/graphic/ecoeridania/4.jpg'
import Img_Ecoeridania_5 from '../assets/graphic/ecoeridania/5.jpg'
import Img_Ecoeridania_6 from '../assets/graphic/ecoeridania/6.jpg'
import Img_Ecoeridania_7 from '../assets/graphic/ecoeridania/7.jpg'
import Img_Ecoeridania_8 from '../assets/graphic/ecoeridania/8.jpg'

import Img_Terrazza_Bonsai_1 from '../assets/graphic/terrazza-bonsai/1.jpg'
import Img_Terrazza_Bonsai_2 from '../assets/graphic/terrazza-bonsai/2.jpg'
import Img_Terrazza_Bonsai_3 from '../assets/graphic/terrazza-bonsai/3.jpg'
import Img_Terrazza_Bonsai_4 from '../assets/graphic/terrazza-bonsai/4.jpg'
import Img_Terrazza_Bonsai_5 from '../assets/graphic/terrazza-bonsai/5.jpg'
import Img_Terrazza_Bonsai_6 from '../assets/graphic/terrazza-bonsai/6.jpg'

import Img_Falconeri_Sanremo_1 from '../assets/graphic/falconeri-sanremo/1.jpg'
import Img_Falconeri_Sanremo_2 from '../assets/graphic/falconeri-sanremo/2.jpg'
import Img_Falconeri_Sanremo_3 from '../assets/graphic/falconeri-sanremo/3.jpg'
import Img_Falconeri_Sanremo_4 from '../assets/graphic/falconeri-sanremo/4.jpg'
import Img_Falconeri_Sanremo_5 from '../assets/graphic/falconeri-sanremo/5.jpg'
import Img_Falconeri_Sanremo_6 from '../assets/graphic/falconeri-sanremo/6.jpg'
import Img_Falconeri_Sanremo_7 from '../assets/graphic/falconeri-sanremo/7.jpg'
import Img_Falconeri_Sanremo_8 from '../assets/graphic/falconeri-sanremo/8.jpg'

// Illustration

import Img_Matematicare_1 from '../assets/illustration/matematicare/1.jpg'
import Img_Matematicare_2 from '../assets/illustration/matematicare/2.jpg'
import Img_Matematicare_3 from '../assets/illustration/matematicare/3.jpg'
import Img_Matematicare_4 from '../assets/illustration/matematicare/4.jpg'
import Img_Matematicare_5 from '../assets/illustration/matematicare/5.jpg'
import Img_Matematicare_6 from '../assets/illustration/matematicare/6.jpg'

import Img_Ora_Guido_Io_1 from '../assets/illustration/ora-guido-io/1.jpg'
import Img_Ora_Guido_Io_2 from '../assets/illustration/ora-guido-io/2.jpg'
import Img_Ora_Guido_Io_3 from '../assets/illustration/ora-guido-io/3.jpg'
import Img_Ora_Guido_Io_4 from '../assets/illustration/ora-guido-io/4.jpg'
import Img_Ora_Guido_Io_5 from '../assets/illustration/ora-guido-io/5.jpg'
import Img_Ora_Guido_Io_6 from '../assets/illustration/ora-guido-io/6.jpg'

import Img_Ecoconsigli_1 from '../assets/illustration/ecoconsigli/1.jpg'
import Img_Ecoconsigli_2 from '../assets/illustration/ecoconsigli/2.jpg'
import Img_Ecoconsigli_3 from '../assets/illustration/ecoconsigli/3.jpg'
import Img_Ecoconsigli_4 from '../assets/illustration/ecoconsigli/4.jpg'
import Img_Ecoconsigli_5 from '../assets/illustration/ecoconsigli/5.jpg'
import Img_Ecoconsigli_6 from '../assets/illustration/ecoconsigli/6.jpg'

import Img_Carbonara_1 from '../assets/illustration/carbonara/1.jpg'
import Img_Carbonara_2 from '../assets/illustration/carbonara/2.jpg'
import Img_Carbonara_3 from '../assets/illustration/carbonara/3.jpg'
import Img_Carbonara_4 from '../assets/illustration/carbonara/4.jpg'

import Img_Luogocomune_1 from '../assets/illustration/luogocomune/1.jpg'
import Img_Luogocomune_2 from '../assets/illustration/luogocomune/2.jpg'
import Img_Luogocomune_3 from '../assets/illustration/luogocomune/3.jpg'
import Img_Luogocomune_4 from '../assets/illustration/luogocomune/4.jpg'
import Img_Luogocomune_5 from '../assets/illustration/luogocomune/5.jpg'
import Img_Luogocomune_6 from '../assets/illustration/luogocomune/6.jpg'

import Img_Collettivo_1 from '../assets/illustration/collettivo/1.jpg'
import Img_Collettivo_2 from '../assets/illustration/collettivo/2.jpg'
import Img_Collettivo_3 from '../assets/illustration/collettivo/3.jpg'
import Img_Collettivo_4 from '../assets/illustration/collettivo/4.jpg'
import Img_Collettivo_5 from '../assets/illustration/collettivo/5.jpg'
import Img_Collettivo_6 from '../assets/illustration/collettivo/6.jpg'